/**
 * POC功能已关闭提示组件
 *
 * @author page
 * @date 2026-08-04
 */
import React from 'react';
import {Button} from 'antd';
import {WarningOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import styles from './DisabledPocNotice.module.css';

interface DisabledPocNoticeProps {
    title?: string;
    message?: string;
}

/**
 * 默认文案
 */
const defaultTitle = '功能已关闭';
const defaultMessage = '该POC功能正在维护中，暂时不对外开放。\n感谢您的理解与支持。';

const DisabledPocNotice: React.FC<DisabledPocNoticeProps> = ({
                                                                 title = defaultTitle,
                                                                 message = defaultMessage
                                                             }) => {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <WarningOutlined className={styles.icon}/>
                <h2 className={styles.title}>{title}</h2>
                <p className={styles.message}>{message}</p>
                <Button
                    type="primary"
                    size="large"
                    onClick={() => navigate('/')}
                >
                    返回首页
                </Button>
            </div>
        </div>
    );
};

export default DisabledPocNotice;
